"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.string.link");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const molecules_1 = require("@components/molecules");
var Quotations = function Quotations(_ref) {
    var _ref$noBorder = _ref.noBorder, noBorder = _ref$noBorder === void 0 ? false : _ref$noBorder, quotations = _ref.quotations, className = _ref.className, images = _ref.images;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, {
        className: className
    }, quotations.map(function (q, i) {
        var _images, _images$file, _images2, _images2$file;
        return /*#__PURE__*/ react_1.default.createElement(molecules_1.Quotation, {
            quote: q.quote,
            credit: q.credit,
            link: q.link,
            key: i,
            noBorder: noBorder,
            leftImage: (_images = images[i % 3 * 2]) === null || _images === void 0 ? void 0 : (_images$file = _images.file) === null || _images$file === void 0 ? void 0 : _images$file.url,
            rightImage: (_images2 = images[i % 3 * 2 + 1]) === null || _images2 === void 0 ? void 0 : (_images2$file = _images2.file) === null || _images2$file === void 0 ? void 0 : _images2$file.url
        });
    }));
};
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "Quotations__Wrapper",
    componentId: "sc-14r8403-0"
})([""]);
exports.default = Quotations;
